import { InitialStateType } from "./reducers/Reducer"
import { MissionType } from "./types/MissionsTypes"

export const initialSelectedMission: MissionType = {
    mission_id: null,
    mission_name: "",
    flight_num: 1,
    sensor_id_1: null,
    sensor_id_2: null,
    platform_id: null,
    flight_plan_id: null,
    project_number: null,
    flown_date: "",
    operator_1_id: null,
    operator_2_id: null,
    pilot_1_id: null,
    pilot_2_id: null,
    base_airport: null,
    manager_id: null,
    flight_notes: null,
    sensor_notes: null,
    error_notes: null,
    error_action: null,
    tomorrow_notes: null,
    flight_blog: null,
    source_file: null,
    flight_plan: [],
    vendor_name: null,
    sorties: [],
    weather_recording_selections: [],
    no_fly_selections: [],
    weather_conditions: [],
    ground_conditions: [],
    field_quicklook_selections: [],
}

export const initialState: InitialStateType = {
    missions: {
        warnings: [],
        selectedMission: initialSelectedMission,
        selectedMissionId: null,
        parsedMissions: [],
        activeFlow: null,
        isVendorFlow: false,
        isDeleting: false,
        employeeList: {
            employees: [],
            project_employees: {
                pilots: [],
                operators: [],
                managers: [],
                reviewers: [],
            },
            nexus_employees: {
                pilots: [],
                operators: [],
                managers: [],
                reviewers: [],
            },
        },
        vendorNameList: [],
        platformList: {
            platforms: [],
            project_platforms: [],
        },
        airportList: {
            airports: [],
            project_airports: [],
        },
        loadingFlightplanList: false,
    },
}
